export const TipoAnalise = {
  LEGIBILIDADE: 'legibilidade',
  LEGIBILIDADE_VOZ_PASSIVA: 'legibilidadeVozPassiva',
  LEGIBILIDADE_ORTOGRAFIA: 'legibilidadeOrtografia',
  LEGIBILIDADE_GRAMATICA: 'legibilidadeGramatica',
  TEXTUAL: 'textual',
  NAO_TEXTUAL: 'nao_textual'
};

export const obterTiposAnalise = () => Object.values(TipoAnalise);